import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

function DashboardClient() {
  const [user, setUser] = useState(null);
  const [projets, setProjets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [onglet, setOnglet] = useState('projets');
  const navigate = useNavigate();

  useEffect(() => {
    const userData = localStorage.getItem('user');
    const token = localStorage.getItem('token');

    if (!userData || !token) {
      navigate('/login');
      return;
    }

    setUser(JSON.parse(userData));
    chargerProjets(token);
  }, [navigate]);

  const chargerProjets = async (token) => {
    try {
      const response = await axios.get('https://efe-systems.com/api/projets', {
        headers: { Authorization: `Bearer ${token}` }
      });
      const projetsData = response.data.data || response.data;
      setProjets(Array.isArray(projetsData) ? projetsData : []);
    } catch (error) {
      console.error('Erreur:', error);
      setProjets([]);
    } finally {
      setLoading(false);
    }
  };

  const deconnexion = async () => {
    const token = localStorage.getItem('token');
    try {
      await axios.post('https://efe-systems.com/api/logout', {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
    } catch (e) {}
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/login');
  };

  const statutConfig = {
    'en_attente':  { label: 'En attente',     couleur: '#F5C500', bg: 'rgba(245,197,0,0.12)',    icone: '⏳' },
    'en_cours':    { label: 'En cours',        couleur: '#1A1AE6', bg: 'rgba(26,26,230,0.12)',    icone: '🔄' },
    'phase_test':  { label: 'Phase de test',   couleur: '#6B21E8', bg: 'rgba(107,33,232,0.12)',   icone: '🧪' },
    'en_revision': { label: 'En révision',     couleur: '#0EA5E9', bg: 'rgba(14,165,233,0.12)',   icone: '✏️' },
    'livre':       { label: 'Livré',           couleur: '#10B981', bg: 'rgba(16,185,129,0.12)',   icone: '✅' },
    'archive':     { label: 'Archivé',         couleur: '#6B7280', bg: 'rgba(107,114,128,0.12)',  icone: '📦' },
  };

  if (loading) {
    return (
      <div style={{ minHeight: '100vh', background: '#f8f9ff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div className="text-center">
          <div className="text-4xl mb-4">⚡</div>
          <p style={{ color: '#1A1AE6', fontWeight: '600' }}>Chargement...</p>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', background: '#f8f9ff' }}>
      <Navbar />

      {/* Header */}
      <div style={{ background: '#050510', paddingTop: '80px' }}>
        <div className="max-w-6xl mx-auto px-6 py-10">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-gray-400 text-sm mb-1">Espace Client</p>
              <h1 className="text-3xl font-extrabold text-white">
                Bonjour, <span style={{ color: '#F5C500' }}>{user?.prenom} {user?.nom}</span> 👋
              </h1>
              <p className="text-gray-400 mt-1 text-sm">Bienvenue sur votre espace EFE Systems</p>
            </div>
            <button
              onClick={deconnexion}
              className="px-4 py-2 rounded-xl text-sm font-semibold transition hover:opacity-80"
              style={{ background: 'rgba(239,68,68,0.15)', color: '#EF4444', border: '1px solid rgba(239,68,68,0.3)' }}
            >
              Déconnexion
            </button>
          </div>

          {/* Stats rapides */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-8">
            {[
              { label: 'Projets total',  valeur: projets.length,                                          icone: '📁', couleur: '#1A1AE6' },
              { label: 'En cours',       valeur: projets.filter(p => p.statut === 'en_cours').length,     icone: '🔄', couleur: '#F5C500' },
              { label: 'Livrés',         valeur: projets.filter(p => p.statut === 'livre').length,        icone: '✅', couleur: '#10B981' },
              { label: 'En attente',     valeur: projets.filter(p => p.statut === 'en_attente').length,   icone: '⏳', couleur: '#6B21E8' },
            ].map((stat, i) => (
              <div key={i} className="rounded-2xl p-4 text-center"
                style={{ background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.1)' }}>
                <div className="text-2xl mb-1">{stat.icone}</div>
                <p className="text-2xl font-extrabold" style={{ color: stat.couleur }}>{stat.valeur}</p>
                <p className="text-gray-400 text-xs mt-1">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Contenu principal */}
      <div className="max-w-6xl mx-auto px-6 py-10">

        {/* Onglets */}
        <div className="flex gap-2 mb-8">
          {[
            { id: 'projets',  label: '📁 Mes Projets' },
            { id: 'messages', label: '💬 Messages' },
            { id: 'fichiers', label: '📎 Fichiers' },
          ].map((tab) => (
            <button
              key={tab.id}
              onClick={() => setOnglet(tab.id)}
              className="px-5 py-2 rounded-xl text-sm font-semibold transition"
              style={{
                background: onglet === tab.id ? '#1A1AE6' : 'white',
                color: onglet === tab.id ? 'white' : '#6B7280',
                border: `1px solid ${onglet === tab.id ? '#1A1AE6' : 'rgba(0,0,0,0.08)'}`,
                boxShadow: onglet === tab.id ? '0 4px 15px rgba(26,26,230,0.3)' : 'none',
              }}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {/* Contenu onglet Projets */}
        {onglet === 'projets' && (
          <div className="flex flex-col gap-4">
            {projets.length === 0 ? (
              <div className="text-center py-20 rounded-3xl bg-white"
                style={{ border: '1px solid rgba(0,0,0,0.06)', boxShadow: '0 2px 15px rgba(0,0,0,0.05)' }}>
                <p className="text-5xl mb-4">📁</p>
                <p className="font-bold text-xl mb-2" style={{ color: '#0F0F2D' }}>Aucun projet pour le moment</p>
                <p className="text-gray-400 text-sm mb-6">Démarrez votre premier projet avec EFE Systems</p>
                <Link to="/demande-projet"
                  className="px-6 py-3 rounded-xl text-sm font-semibold transition hover:opacity-90 inline-block"
                  style={{ background: '#1A1AE6', color: 'white', textDecoration: 'none' }}>
                  Demander un devis →
                </Link>
              </div>
            ) : (
              projets.map((projet, index) => {
                const statut = statutConfig[projet.statut] || { label: projet.statut, couleur: '#6B7280', bg: 'rgba(107,114,128,0.1)', icone: '📋' };
                return (
                  <div key={index} className="rounded-2xl bg-white overflow-hidden transition hover:shadow-lg"
                    style={{ border: '1px solid rgba(0,0,0,0.06)', boxShadow: '0 2px 15px rgba(0,0,0,0.05)' }}>

                    {/* Bande colorée en haut */}
                    <div className="h-1.5 w-full" style={{ background: statut.couleur }}></div>

                    <div className="p-6">
                      <div className="flex items-start justify-between mb-4">
                        <div>
                          <h3 className="font-extrabold text-xl mb-1" style={{ color: '#0F0F2D' }}>{projet.titre}</h3>
                          <p className="text-gray-500 text-sm">{projet.description}</p>
                        </div>
                        <span className="px-3 py-1.5 rounded-full text-xs font-bold flex-shrink-0 ml-4 flex items-center gap-1"
                          style={{ background: statut.bg, color: statut.couleur }}>
                          {statut.icone} {statut.label}
                        </span>
                      </div>

                      {/* Barre de progression */}
                      <div className="mb-4">
                        <div className="flex justify-between text-xs mb-1.5" style={{ color: '#6B7280' }}>
                          <span>Progression du projet</span>
                          <span className="font-bold" style={{ color: statut.couleur }}>{projet.progression || 0}%</span>
                        </div>
                        <div className="rounded-full h-3" style={{ background: '#f0f0f0' }}>
                          <div className="h-3 rounded-full transition-all duration-500"
                            style={{ width: `${projet.progression || 0}%`, background: `linear-gradient(90deg, ${statut.couleur}, ${statut.couleur}99)` }}>
                          </div>
                        </div>
                      </div>

                      {/* Infos */}
                      <div className="flex flex-wrap gap-4 text-xs" style={{ color: '#9CA3AF' }}>
                        {projet.date_debut && (
                          <span className="flex items-center gap-1">
                            📅 Début : <strong>{new Date(projet.date_debut).toLocaleDateString('fr-FR')}</strong>
                          </span>
                        )}
                        {projet.date_livraison_prevue && (
                          <span className="flex items-center gap-1">
                            🎯 Livraison : <strong>{new Date(projet.date_livraison_prevue).toLocaleDateString('fr-FR')}</strong>
                          </span>
                        )}
                        {projet.service && (
                          <span className="flex items-center gap-1">
                            🔧 <strong>{projet.service.nom}</strong>
                          </span>
                        )}
                        {projet.montant_total && (
                          <span className="flex items-center gap-1">
                            💰 <strong>{projet.montant_total} $</strong>
                          </span>
                        )}
                      </div>

                      {/* Notes client */}
                      {projet.notes_client && (
                        <div className="mt-4 p-4 rounded-xl text-sm"
                          style={{ background: 'rgba(26,26,230,0.05)', border: '1px solid rgba(26,26,230,0.15)', color: '#1A1AE6' }}>
                          💬 <strong>Note de votre équipe :</strong> {projet.notes_client}
                        </div>
                      )}
                    </div>
                  </div>
                );
              })
            )}
          </div>
        )}

        {/* Messages */}
        {onglet === 'messages' && (
          <div className="text-center py-20 rounded-3xl bg-white"
            style={{ border: '1px solid rgba(0,0,0,0.06)' }}>
            <p className="text-5xl mb-4">💬</p>
            <p className="font-bold text-xl mb-2" style={{ color: '#0F0F2D' }}>Messages à venir</p>
            <p className="text-gray-400 text-sm">La messagerie interne sera disponible prochainement.</p>
          </div>
        )}

        {/* Fichiers */}
        {onglet === 'fichiers' && (
          <div className="text-center py-20 rounded-3xl bg-white"
            style={{ border: '1px solid rgba(0,0,0,0.06)' }}>
            <p className="text-5xl mb-4">📎</p>
            <p className="font-bold text-xl mb-2" style={{ color: '#0F0F2D' }}>Fichiers à venir</p>
            <p className="text-gray-400 text-sm">Vos livrables et documents seront disponibles ici.</p>
          </div>
        )}

        {/* Bouton demander un devis */}
        <div className="mt-10 text-center">
          <Link to="/demande-projet"
            className="inline-flex items-center gap-2 px-8 py-4 rounded-2xl font-semibold transition hover:opacity-90"
            style={{ background: '#1A1AE6', color: 'white', textDecoration: 'none', boxShadow: '0 4px 20px rgba(26,26,230,0.3)' }}>
            ➕ Démarrer un nouveau projet
          </Link>
        </div>

      </div>

      <Footer />
    </div>
  );
}

export default DashboardClient;